// there shouldn't be a problem with not checking event here
// since we can only hit this action from the refresh actor
// onDone or onError
export function setIgnoreRefreshToken() {
  return {
    ignoreRefreshToken: true,
  };
}

export default setIgnoreRefreshToken;
